/* eslint-disable */

import axios from 'axios';

export default ({
  state: {
    token: localStorage.getItem('token'),
    status: '',
    authHeader: '',
    authRoleState:''
  },
  mutations: {
    authSuccess(state, token) {
      state.token = token;
      state.status = 'success';
    },
    authRole(state, role) {
      state.authRoleState = role;
    },
    authError(state) {
      state.token = '';
      state.status = 'error';
    },
    authLogout(state) {
      state.token = '';
      state.status = '';
    },
    setAuth(state, value) {
      state.authHeader = value
    }
  },
  actions: {
    loginPostAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/admin/login/', payload)
          .then((response) => {
            context.commit('authSuccess', response.data.data.access);
            context.commit('authRole', response.data.data.user.profile.role);
            // localStorage.setItem('authRole', response.data.data.user.profile.role);
            localStorage.setItem('token', response.data.data.access);
            axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.data.access;
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            resolve(response);
          })
          .catch((error) => {
            localStorage.removeItem('token');
            context.commit('authError');
            reject(error);
          })
      })
    },
    logout(context) {
      return new Promise((resolve, reject) => {
        context.commit('authLogout');
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        resolve();
      })
    },
    getAuthHeader(context) {
      context.commit('setAuth', 'Bearer ' + localStorage.getItem('token'))
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    getAuthHeaderfun: state => state.authHeader,
    authRoleStateDetails: state => state.authRoleState,
  }
})